export default __webpack_public_path__ + "static/media/zapsplat_impact_hit_hard_broken_glass_short_slam_001_63097.c94da840.mp3";